<!-- <div class="fpassword-container">
    <form [formGroup]="forgotPasswrdConfirmForm" (ngSubmit)="onSubmit()">
        <div class="card-top card-head">
            <h3>Reset Password</h3>
            <p>Please fill the required field.</p>
        </div>
        <div class="form-row">
            <div class="form-item">
                <label for="newPassword">New Password (Min 8 & Max 14 Characters)*</label>
                <input type="password" id="newPassword" formControlName="newPassword" required />
                <div  class="error" *ngIf="forgotPasswrdConfirmForm.get('newPassword')?.invalid && forgotPasswrdConfirmForm.get('newPassword')?.touched">
                <small *ngIf="forgotPasswrdConfirmForm.get('newPassword')?.errors?.['required']">New Password is required.</small>
                <small *ngIf="forgotPasswrdConfirmForm.get('newPassword')?.errors?.['minlength']">New Password Should be Minimum 8 characters.</small>

                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-item">
                <label for="confirmPassword">Confirm Password (Min 8 & Max 14 Characters)**</label>
                <div class="eye-visiblie">
                    <input [type]="isPasswordVisible ? 'text' : 'password'" formControlName="confirmPassword" id="confirmPassword" required />
                    <div (click)="togglePasswordVisibility()">
                      <fa-icon *ngIf="isPassword" [icon]="isPasswordsMatch ? ['fas', 'check'] : ['fas', 'xmark']" [class]="isPasswordsMatch ? 'match-indicator': 'unmatch-indicator'"></fa-icon>
                      <fa-icon [icon]="isPasswordVisible ? ['fas', 'eye'] : ['fas', 'eye-slash']" class="fa-thin"></fa-icon>
                    </div>
                </div>
                <div  class="error" *ngIf="forgotPasswrdConfirmForm.get('confirmPassword')?.invalid && forgotPasswrdConfirmForm.get('confirmPassword')?.touched">
                <small *ngIf="forgotPasswrdConfirmForm.get('confirmPassword')?.errors?.['required']">Confirm Password is required.</small>
                <small *ngIf="forgotPasswrdConfirmForm.get('confirmPassword')?.errors?.['minlength']">Confirm Password Should be Minimum 8 characters.</small>

                </div>
            </div>
            <input  id="token" formControlName="token" hidden/>
        </div>
        <div class="actions">
            <button class="btn-action" type="submit">
                <fa-icon [icon]="['fas', 'unlock-keyhole']" class="fa-thin"></fa-icon>
                Confirm
            </button>
           
        </div>
    </form>
</div> -->

<div class="public-page">
   <div class="public-container">
      <!-- <header class="top-header">
         <h3>Forgot Password?</h3>
         <p>Please enter your registered email to receive a link for Reset password.</p>
      </header> -->
      
      <!-- Main Content -->
      <div class="main-content">
        <div class="fp-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                <path fill="none" stroke="#a74ae1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15.362 9.065l1.32 1.32c.995.995 1.345-.84 2.734-1.07c.466-.078.877-.236 1.053-.752c.156-.456-.021-.885-.574-1.438L18.5 5.731M7.5 21a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9m3.5-8L21 3" />
            </svg>
        </div>

        <div class="header-content-fp">
            <h4>Set new password</h4>
            <p>Please fill the required fields</p>
        </div>
         
        <form class="form"[formGroup]="forgotPasswrdConfirmForm" (ngSubmit)="onSubmit()">
            <div class="form-row">
               <div class="form-group">
                    <label for="newPassword">New Password <small>(Min 8 & Max 14 Characters) *</small></label>
                    <input type="password" id="newPassword" formControlName="newPassword" required />
                    <div  class="error" *ngIf="forgotPasswrdConfirmForm.get('newPassword')?.invalid && forgotPasswrdConfirmForm.get('newPassword')?.touched">
                        <small *ngIf="forgotPasswrdConfirmForm.get('newPassword')?.errors?.['required']">New Password is required.</small>
                        <small *ngIf="forgotPasswrdConfirmForm.get('newPassword')?.errors?.['minlength']">New Password Should be Minimum 8 characters.</small>
                    </div>
               </div>
               <div class="form-group">
                    <label for="confirmPassword">Confirm Password <small>(Min 8 & Max 14 Characters) *</small></label>
                    <div class="eye-visiblie">
                        <input [type]="isPasswordVisible ? 'text' : 'password'" formControlName="confirmPassword" id="confirmPassword" required />
                        <div (click)="togglePasswordVisibility()">
                        <fa-icon *ngIf="isPassword" [icon]="isPasswordsMatch ? ['fas', 'check'] : ['fas', 'xmark']" [class]="isPasswordsMatch ? 'match-indicator': 'unmatch-indicator'"></fa-icon>
                        <fa-icon [icon]="isPasswordVisible ? ['fas', 'eye'] : ['fas', 'eye-slash']" class="fa-thin"></fa-icon>
                        </div>
                    </div>
                    <div  class="error" *ngIf="forgotPasswrdConfirmForm.get('confirmPassword')?.invalid && forgotPasswrdConfirmForm.get('confirmPassword')?.touched">
                        <small *ngIf="forgotPasswrdConfirmForm.get('confirmPassword')?.errors?.['required']">Confirm Password is required.</small>
                        <small *ngIf="forgotPasswrdConfirmForm.get('confirmPassword')?.errors?.['minlength']">Confirm Password Should be Minimum 8 characters.</small>
                    </div>
               </div>
            </div>
         
            <div class="btn-submit">
                <button type="submit"
                        [disabled]="loadingService.isLoading('reset-password')">
                  Reset Password
                    <app-spinner
                            *ngIf="loadingService.isLoading('reset-password')"
                            size="small"
                    ></app-spinner>
               </button>
            </div>
            <div class="back-login">
                <a (click)="login()">← Back to log in</a>
            </div>
        </form>
      </div>
   </div>
</div>
    
 